import { render } from "./SplashScreenModal.vue?vue&type=template&id=3dbaee9a&scoped=true"
import script from "./SplashScreenModal.vue?vue&type=script&lang=js"
export * from "./SplashScreenModal.vue?vue&type=script&lang=js"

import "./SplashScreenModal.vue?vue&type=style&index=0&id=3dbaee9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbaee9a"]])

export default __exports__